import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import "./accordian.scss";

const Accordian = () => {

  return (
    <div className="panelbar-wrapper">
      <PanelBar>
        <PanelBarItem expanded={false} title="What if I cannot make myself available right now?">
        You can set the time of joining under the Availability option in the Myprofile section
        </PanelBarItem>
        <PanelBarItem title='What if I cannot clear the Technical Assessment in one attempt?'>
        You can take the test in the next three months
        </PanelBarItem>
        <PanelBarItem title="What if the contract company does not pay me on time?">
        Ellow will take care of all the issues once you are onboarded with us
        </PanelBarItem>
      </PanelBar>
    </div>
  );
};

export default Accordian